// src/services/api/productTags.js
import { apiClient } from './base';

export const createProductTag = async (tagData) => {
  try {
    const response = await apiClient.post('/product-tags', tagData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductTags = async (params = {}) => {
  try {
    const response = await apiClient.get('/product-tags', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProductTag = async (tagId) => {
  try {
    const response = await apiClient.get(`/product-tags/${tagId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductTag = async (tagId, tagData) => {
  try {
    const response = await apiClient.put(`/product-tags/${tagId}`, tagData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProductTag = async (tagId) => {
  try {
    const response = await apiClient.delete(`/product-tags/${tagId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};